import {useAppSelector} from "../../../redux/hooks";
import {dashboardStore} from "../store/dashboardPageStore";

export interface IDashboardUserPointsToLevelLogic {
  nextLevel?: number;
  pointsEarnedTowardsNextLevel?: number;
  pointsEarnableWithinCurrentLevel?: number;
}

export const useDashboardUserPointsToLevelLogic = (): IDashboardUserPointsToLevelLogic => {
  const nextLevel = useAppSelector(() => dashboardStore.getUserSummary().nextLevel);
  const pointsEarnedTowardsNextLevel = useAppSelector(() => dashboardStore.getUserSummary().pointsEarnedTowardsNextLevel);
  const pointsEarnableWithinCurrentLevel = useAppSelector(() => dashboardStore.getUserSummary().pointsEarnableWithinCurrentLevel);
  return {
    nextLevel,
    pointsEarnedTowardsNextLevel,
    pointsEarnableWithinCurrentLevel,
  };
}
